import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider, FacebookAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { initializeAppCheck, ReCaptchaV3Provider } from 'firebase/app-check';

// --- Configuração do Firebase --------------------------------------------
// ATENÇÃO: Estas chaves são do seu projeto.
const firebaseConfig = {
    apiKey: "AIzaSyDIGBwkgRD42mPBXfreoTWTqCS-z0sNGi4",
    authDomain: "bolao-4dbb2.firebaseapp.com",
    projectId: "bolao-4dbb2",
    storageBucket: "bolao-4dbb2.firebasestorage.app",
    messagingSenderId: "316856500835",
    appId: "1:316856500835:web:66a109039a20e9797dae56",
};

// --- Inicialização do Firebase --------------------------------------------
const app = initializeApp(firebaseConfig);

// Inicializa o App Check
// Ative o debug token localmente se necessário para testes em localhost
if (window.location.hostname === 'localhost') {
    // eslint-disable-next-line no-restricted-globals
    window.FIREBASE_APPCHECK_DEBUG_TOKEN = true;
}

initializeAppCheck(app, {
    provider: new ReCaptchaV3Provider('6LfKTVUsAAAAAM6xbMmef3dYmx_tdUdLkwWCHrlU'),
    isTokenAutoRefreshEnabled: true,
});

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const googleProvider = new GoogleAuthProvider();
export const facebookProvider = new FacebookAuthProvider();
